var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M5.5 11.5C2.46235 11.5 0 9.03765 0 6C0 2.96235 2.46235 0.5 5.5 0.5C8.53765 0.5 11 2.96235 11 6C11 9.03765 8.53765 11.5 5.5 11.5ZM5.5 10.4C6.66695 10.4 7.78611 9.93643 8.61127 9.11127C9.43643 8.28611 9.9 7.16695 9.9 6C9.9 4.83305 9.43643 3.71389 8.61127 2.88873C7.78611 2.06357 6.66695 1.6 5.5 1.6C4.33305 1.6 3.21389 2.06357 2.38873 2.88873C1.56357 3.71389 1.1 4.83305 1.1 6C1.1 7.16695 1.56357 8.28611 2.38873 9.11127C3.21389 9.93643 4.33305 10.4 5.5 10.4ZM5.5 5.2223L7.0554 3.66635L7.83365 4.4446L6.2777 6L7.83365 7.5554L7.0554 8.33365L5.5 6.7777L3.9446 8.33365L3.16635 7.5554L4.7223 6L3.16635 4.4446L3.9446 3.66635L5.5 5.2223Z",
    fill: "#F55468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.82e4719514d6ea137e4725466b07def1.svg";
export { ForwardRef as ReactComponent };